import React from 'react';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Button, Col, FormGroup, Label, Spinner } from 'reactstrap';
import { getInputStatus } from '../../../services/commonServices';
import authenticatedFetcher from '../../../services/fetcher';
import { Types } from '../../../utils/DynamicForm.config';
import { toastError } from '../../../utils/ToastConfig';

const TypeFormActionInput = (props) => {
	const {
		id,
		label,
		name = '',
		value,
		placeholder,
		onChange,
		required,
		editable = true,
		isEditing = true,
		errors,
		style,
		options = {},
		labelColumn = { xs: '6', md: '2' },
		inputColumn = { xs: '6', md: '10' },
		alwaysEditableFields,
	} = props;

	const {
		action_txt = 'Action',
		endpoint,
		method = 'POST',
		payload = {},
		put_in_fields
	} = options;

	const [localValue, setLocalValue] = useState(value || '');
	const [isLoading, setIsLoading] = useState(false);
	const [actionMessage, setActionMessage] = useState(null);

	useEffect(() => {
		setLocalValue((prev) => (prev === value ? prev : value));
	}, [value]);

	const handleChange = ({ target: { value } }) => {
		setLocalValue(value);
		onChange({ target: { value, name } });
		setActionMessage(null);
	};

	const getParsedPayload = () => {
		const finalPayload = {};
		for (const [key, val] of Object.entries(payload)) {
			if (val === name) {
				finalPayload[key] = localValue;
			} else {
				finalPayload[key] = val;
			}
		}
		
		if (Object.keys(finalPayload).length === 0) {
			finalPayload[name] = localValue;
		}

		return finalPayload;
	};

	const handleAction = async () => {
		if (!endpoint) return;
		setIsLoading(true);
		setActionMessage(null);

		try {
			const finalPayload = getParsedPayload();

			const res = await authenticatedFetcher({
				path: endpoint,
				method: method,
				body: method !== 'GET' ? finalPayload : undefined,
				urlParams: method === 'GET' ? finalPayload : undefined
			});

		if (!res.error) {
				setActionMessage({
					text: res.message,
					color: res.color
				});
				if (Array.isArray(put_in_fields) && put_in_fields.length) {
					put_in_fields.forEach((fieldName) => {
						if (fieldName in res) {
							onChange({ target: { name: fieldName, value: res[fieldName] } });
						}
					});
				}
				return;
			}
			setActionMessage({
				text: res.error_data?.message,
				color: res.error_data?.color
			});
		} catch (error) {
			toastError(error.error_data?.details);
		} finally {
			setIsLoading(false);
		}
	};

	const isEditable = Array.isArray(alwaysEditableFields)
		? alwaysEditableFields.some((item) => item === name) || editable
		: editable;

	if (label === 'ID (web)') {
		return (
			<FormGroup>
				<Label for={name} style={{ color: '#DCDCDC' }}>{label}</Label>
				: {localValue}
			</FormGroup>
		);
	}

	return (
		<FormGroup tag="fieldset" row>
			{label !== false && (
				<Col {...labelColumn} className={actionMessage ? labelColumn.className : clsx(labelColumn.className, 'align-self-center')}>
					<Label style={style} for={`form-2-${id}`} className="col-form-label">
						{required ? '*' : ''} {label}
					</Label>
				</Col>
			)}
			<Col {...inputColumn} className={inputColumn.className}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
					<div style={{ flex: 1, display: 'flex' }}>
						<Form.Control
							id={`form-2-${id}`}
							type="text"
							name={name}
							value={localValue || ''}
							placeholder={placeholder}
							onChange={handleChange}
							disabled={!isEditable || !isEditing}
							className={clsx(!isEditing && 'pl-0', getInputStatus(required, localValue, errors))}
						/>
					</div>
					<Button 
						onClick={handleAction} 
						disabled={isLoading || !isEditable || !isEditing || !localValue}
						className="btn-action-input"
					>
						{isLoading ? <Spinner size="sm" /> : action_txt}
					</Button>
				</div>
				{actionMessage && (
					<div style={{ color: actionMessage.color, marginTop: '5px', fontSize: '0.9rem', fontWeight: 500 }}>
						{actionMessage.text}
					</div>
				)}
			</Col>
		</FormGroup>
	);
};

TypeFormActionInput.propTypes = Types.inputType;

export default TypeFormActionInput;
